import { Box, Flex, FormControl, FormErrorMessage, FormLabel, Text } from '@chakra-ui/react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import Asterisk from '@/components/common/Asterisk';
import { useGetCategories } from '@/services/addProduct';
import CustomSelect from '@/components/common/CustomSelect';
import { useEffect, useState } from 'react';
import { AddOnFormData } from '@/services/addAddons/types';

interface CategorySelectionSectionProps {
  control: Control<AddOnFormData>;
  errors: FieldErrors<AddOnFormData>;
  id?: string;
}

interface Category {
  id: string | number;
  name: string;
}

const CategorySelectionSection = ({ control, errors, id }: CategorySelectionSectionProps) => {
  const [categoryOptions, setCategoryOptions] = useState<{ id: string; label: string }[]>([]);

  const { data: categories } = useGetCategories();

  useEffect(() => {
    if (categories) {
      setCategoryOptions(
        categories.map((category: Category) => ({
          id: category.id.toString(),
          label: category.name,
        })),
      );
    }
  }, [categories]);

  return (
    <Box
      border="1px solid"
      borderColor="border.default60"
      bg="background.secondary"
      borderRadius="lg"
    >
      <Flex p={4} direction="column" gap={4}>
        <Text fontSize="md" fontWeight="semibold">
          {id ? 'Edit Addons' : 'Add Addons'}
        </Text>

        <FormControl isInvalid={!!errors.categorySelection?.category}>
          <FormLabel
            fontSize="sm"
            color={errors.categorySelection?.category ? 'status.error' : 'text.secondary'}
          >
            Select Category
            <Asterisk />
          </FormLabel>
          <Controller
            name="categorySelection.category"
            control={control}
            render={({ field }) => (
              <CustomSelect
                options={categoryOptions}
                placeholder="Select Category"
                selectedValue={field.value}
                onChange={(value) => field.onChange(value)}
                size="md"
                isFullWidth={true} // already true, kept for clarity
                isSearchable={true}
              />
            )}
          />
          <FormErrorMessage>{errors.categorySelection?.category?.message}</FormErrorMessage>
        </FormControl>
      </Flex>
    </Box>
  );
};

export default CategorySelectionSection;
